import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import adminHttp from "../../../utils/adminHttp";


type Payload = {
  userId: string;

}

export const useUpdateAdminProviderStatus = () => {
  const queryClient = useQueryClient();
  const { mutate, data, variables, ...rest } = useMutation({
    mutationKey: ['update admin provider status'],
    mutationFn: async ({ ...userId }: Payload) => {
      const response = await adminHttp.patch(`providers/active/${userId}`)
      return response.data;
    },

    onSuccess: () => {
      toast.success(
        `updated successfully`,
        { toastId: "customId" }
      );
      queryClient.invalidateQueries({
        queryKey: ["get admin provider list"] as const
      });
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error.response?.statusText || `Error updating data`,
          { toastId: "customId" }
        );

      } else {
        toast.error(
          error?.message
          || "Error processing your request",
        );
      }
    },
  });

  return {
    updateProviderUserStatus: mutate,
    data,
    variables,
    ...rest,
  };
}